import { render } from "./CV.vue?vue&type=template&id=4c3479bb&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import "./CV.vue?vue&type=style&index=0&id=4c3479bb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c3479bb"

export default script